import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { adminOrgBase } from "../config/adminPortalRoutes";

const isCanonicalOrganization = (organization) => {
  try {
    return Boolean(organization?.org_id) && adminOrgBase(organization?.subdomain) === `/org/${organization.subdomain}`;
  } catch {
    return false;
  }
};

export default function useAdminOrganizations(enabled = true) {
  const [state, setState] = useState({ status: enabled ? "loading" : "idle", organizations: [] });

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    setState({ status: "loading", organizations: [] });
    axios.get(`${API}/organizations/admin-portal/options`)
      .then(({ data }) => {
        if (!active) return;
        const organizations = (Array.isArray(data?.organizations) ? data.organizations : []).filter(isCanonicalOrganization);
        setState({ status: "ready", organizations, requiresImpersonation: Boolean(data?.requires_impersonation) });
      })
      .catch(() => { if (active) setState({ status: "error", organizations: [] }); });
    return () => { active = false; };
  }, [enabled]);

  return state;
}
